import { useAuth } from '@/context/AuthContext';
import { X, Crown } from 'lucide-react';
import { Link } from 'react-router-dom';

export const AdBanner = ({ variant = 'banner' }) => {
  const { user } = useAuth();

  // Don't show ads to premium users
  if (user?.is_premium) {
    return null;
  }

  if (variant === 'inline') {
    return (
      <div className="glass rounded-xl p-4 border border-white/10 bg-gradient-to-r from-[#1a1a2e]/50 to-[#16213e]/50">
        <div className="flex items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-lg bg-[#D4AF37]/20 flex items-center justify-center">
              <Crown className="w-5 h-5 text-[#D4AF37]" />
            </div>
            <div>
              <p className="text-[#F5F5F5] font-medium text-sm">Unlock all 105 cocktails</p>
              <p className="text-[#A3A3A3] text-xs">Go Premium for just $1/month</p>
            </div>
          </div>
          <Link
            to="/pricing"
            className="px-4 py-2 bg-[#D4AF37] text-black text-sm font-bold rounded-full hover:bg-[#F4CF57] transition-colors"
          >
            Upgrade
          </Link>
        </div>
      </div>
    );
  }

  // Banner variant (bottom of screen)
  return (
    <div className="fixed bottom-20 md:bottom-4 left-4 right-4 z-40">
      <div className="max-w-lg mx-auto glass rounded-xl p-4 border border-[#D4AF37]/30 bg-gradient-to-r from-[#1a1a2e] to-[#16213e]">
        <div className="flex items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 rounded-xl bg-[#D4AF37]/20 flex items-center justify-center">
              <Crown className="w-6 h-6 text-[#D4AF37]" />
            </div>
            <div>
              <p className="text-[#F5F5F5] font-bold">Go Ad-Free with Premium</p>
              <p className="text-[#A3A3A3] text-sm">Plus 105 cocktails, favorites & more!</p>
            </div>
          </div>
          <Link
            to="/pricing"
            className="px-5 py-2.5 bg-[#D4AF37] text-black font-bold rounded-full hover:bg-[#F4CF57] transition-colors whitespace-nowrap"
            data-testid="ad-upgrade-btn"
          >
            $1/mo
          </Link>
        </div>
      </div>
    </div>
  );
};

export const ProductSuggestionAd = ({ ingredient, affiliate_url }) => {
  // This is the "acceptable" ad for premium users - product suggestions
  return (
    <a
      href={affiliate_url || `https://www.amazon.com/s?k=${encodeURIComponent(ingredient)}`}
      target="_blank"
      rel="noopener noreferrer"
      className="glass rounded-lg p-3 border border-white/10 hover:border-[#D4AF37]/50 transition-colors block"
    >
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 rounded bg-[#D4AF37]/10 flex items-center justify-center text-[#D4AF37] text-xl">
          🛒
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-[#F5F5F5] text-sm font-medium truncate">Buy {ingredient}</p>
          <p className="text-[#A3A3A3] text-xs">Shop on Amazon</p>
        </div>
        <span className="text-[#D4AF37] text-xs">→</span>
      </div>
    </a>
  );
};

export default AdBanner;
